import React from "react";
import { Flex, Sidebar as BdoSidebar } from "@bdo/cornerstone-ui";
import { Logo } from "@/components";
import { SIDEBAR_MIN_WIDTH, SIDEBAR_MAX_WIDTH } from "@/hooks";

const items = [
  {
    id: "1",
    title: "Version 1.0",
    content:
      "Lorem ipsum dolor sit amet consectetur. Amet nam sapien magna scelerisque sit dignissim cras et aliquet. Eu vulputate posuere nibh lacus risus. Mi turpis id semper elit. Diam.",
  },
  {
    id: "2",
    title: "Version 0.9",
    content:
      "Lorem ipsum dolor sit amet consectetur. Amet nam sapien magna scelerisque sit dignissim cras et aliquet. Eu vulputate posuere nibh lacus risus. Mi turpis id semper elit. Diam.",
  },
  {
    id: "3",
    title: "Version 0.8",
    content:
      "Lorem ipsum dolor sit amet consectetur. Amet nam sapien magna scelerisque sit dignissim cras et aliquet. Eu vulputate posuere nibh lacus risus. Mi turpis id semper elit. Diam.",
  },
];

interface SidebarProps {
  children: React.ReactNode;
  width?: number;
  onResizeStart?: (e: React.MouseEvent) => void;
  onResizeDoubleClick?: () => void;
}

export function Sidebar({
  children,
  width = SIDEBAR_MIN_WIDTH,
  onResizeStart,
  onResizeDoubleClick,
}: Readonly<SidebarProps>) {
  return (
    <div
      className="relative flex"
      style={{
        width,
        minWidth: SIDEBAR_MIN_WIDTH,
        maxWidth: SIDEBAR_MAX_WIDTH,
      }}
    >
      <BdoSidebar className="h-full min-w-0 flex-1 overflow-hidden border-r border-mono-lighter px-2xs pt-2xs">
        <BdoSidebar.Header
          logo={<Logo />}
          supportingInfo={
            <Flex gap="sm" align="center">
              <span className="text-mono">{items[0]?.title}</span>
            </Flex>
          }
        />
        <BdoSidebar.Body className="h-full overflow-y-auto">
          <Flex grow className="my-md min-h-0">
            {children}
          </Flex>
        </BdoSidebar.Body>
      </BdoSidebar>
      {onResizeStart && (
        <button
          type="button"
          aria-label="Resize sidebar"
          className="absolute right-0 top-0 h-full w-[4px] cursor-col-resize border-none bg-transparent p-0 hover:bg-mono-lighter active:bg-mono-light"
          onMouseDown={onResizeStart}
          onDoubleClick={onResizeDoubleClick}
        />
      )}
    </div>
  );
}
